import { Space, Typography } from 'antd';
import { ReactNode } from 'react';

interface Props {
  confirmDeleteText: ReactNode;
  confirmationError?: string;
}

const ModalConfirmationContent = ({ confirmDeleteText, confirmationError }: Props) => {
  return (
    <Space orientation="vertical">
      {confirmDeleteText}
      {confirmationError && <Typography.Text type="danger">{confirmationError}</Typography.Text>}
    </Space>
  );
};

export default ModalConfirmationContent;
